// extracted by mini-css-extract-plugin
module.exports = {"banner-wrapper":"HomeBannerTextV2_banner-wrapper__DFyCg","banner-text":"HomeBannerTextV2_banner-text__Hq3O_","banner-subtext":"HomeBannerTextV2_banner-subtext__SUTTi"};